'use client'

import { useEffect } from 'react'
import { captureReferralCodeFromUrl } from '@/lib/referral-capture'

/**
 * Captura el `?ref` de la landing en la primera llegada (web), detrás del
 * master-flag público `NEXT_PUBLIC_REFERRAL_ENABLED` (inerte con la flag OFF).
 * El carrier sobrevive el round-trip same-origin del OAuth y el código se adjunta
 * al fetch de sync.
 *
 * Extraído de `CapacitorBridgeProvider` para mantener ese componente por debajo
 * del umbral de complejidad ciclomática (Code Health) SIN tocar la lógica sensible
 * de espera del bridge nativo de Capacitor.
 */
export function useReferralCaptureOnMount(): void {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_REFERRAL_ENABLED === 'true') {
      captureReferralCodeFromUrl()
    }
  }, [])
}
